<template>
    <div class="CenteredContent">
        <h1 class="title">Your account has been created. Please let us know a little more about you to help us with pairing.
        </h1>
        <h4 class="intro">With more detailed information, we will be able to find the best candidates for you.</h4>
        <div class="inputContainer">
            <a-form :form="form" layout="horizontal" labelAlign="left">
                <h4>Basic Information</h4>
                <a-form-item label="Prefered Name">
                    <a-input size="large" v-decorator="[
                        'username',
                        {
                            rules: [
                                {
                                    required: true,
                                    message: 'Your name is required',
                                },
                            ],
                        },
                    ]"></a-input>
                </a-form-item>
                <a-form-item label="Year of Birth">
                    <a-input-number class="w100" size="large" :min="1938" :max="2023" v-decorator="[
                        'birthday',
                        {
                            rules: [
                                {
                                    required: true,
                                    message: 'Your year of birth is required',
                                },
                            ],
                        },
                    ]" placeholder="Select Birthday" />

                </a-form-item>
                <a-form-item label="Prefered Language">
                    <a-radio-group class="w100" size="large" button-style="solid" v-decorator="[
                        'lang',
                        {
                            rules: [
                                {
                                    required: true,
                                    message: 'Prefered language is required',
                                },
                            ],
                        },
                    ]">
                        <a-radio-button value="en">
                            English
                        </a-radio-button>

                        <a-radio-button value="fr">
                            French
                        </a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="Prefered Communication Method">
                    <a-radio-group class="w100" size="large" button-style="solid" v-decorator="[
                        'communication',
                        {
                            rules: [
                                {
                                    required: true,
                                    message:
                                        'Your prefered communication method is required',
                                },
                            ],
                        },
                    ]">
                        <a-radio-button value="video">Video Call</a-radio-button>
                        <a-radio-button value="audio">Audio Call</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <h4>Special needs </h4>
                <a-form-item label="Accessibility Considerations">
                    <a-select v-decorator="[
                        'accessiblity',
                        {
                            rules: [
                                {
                                    required: true,
                                    message:
                                        'Accessibility Consideration is required',
                                },
                            ],
                        },
                    ]">
                        <a-select-option value="no">No Considerations</a-select-option>
                        <a-select-option value="hearing">Hearing Impairments (Ex. Partial or total inability to
                            hear)</a-select-option>
                        <a-select-option value="visual">Visual Impairments (Ex. Partial loss of sight, total
                            loss of sight, sensitivity to light, colour
                            blindness)</a-select-option>
                        <a-select-option value="communication">Communication Disorders</a-select-option>
                        <a-select-option value="mobility">Mobility Impairments (Ex. Poor manual dexterity,
                            arthritis)</a-select-option>
                        <a-select-option value="learning">Learning Disability (Ex. Dyslexia, Attention Deficit
                            Disorder, Attention Deficit Hyperactivity
                            Disorder)</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="Province">
                    <a-select placeholder="Select Province" v-decorator="[
                        'province',
                        {
                            rules: [
                                {
                                    required: true,
                                    message: 'Province is required',
                                },
                            ],
                        },
                    ]">
                        <a-select-option value="ON">Ontario</a-select-option>
                        <a-select-option value="QC">Qubec</a-select-option>
                        <a-select-option value="AB">Alberta</a-select-option>
                        <a-select-option value="BC">British Columbia</a-select-option>
                        <a-select-option value="NS">Nova Scotia</a-select-option>
                        <a-select-option value="MB">Manitoba</a-select-option>
                        <a-select-option value="NB">New Brunswick</a-select-option>
                        <a-select-option value="PE">Prince Edward Island</a-select-option>
                        <a-select-option value="SK">Saskatchewan</a-select-option>
                        <a-select-option value="NL">Newfoundland and Labrador</a-select-option>
                    </a-select>
                </a-form-item>
                <h4>More about you</h4>
                <a-form-item label="Your Interests">
                    <a-checkbox-group style="font-size: 1.3rem; font-weight: 700" :options="options" v-decorator="[
                        'interests',
                        {
                            rules: [
                                {
                                    required: true,
                                    message: 'Interests is required',
                                },
                                {
                                        validator: (_, value, cb) => {
                                            value.length <= 5
                                                ? cb()
                                                : cb('You may select at most 5 interests');
                                        },
                                    },
                            ],
                        },
                    ]">
                    </a-checkbox-group>
                </a-form-item>
                <a-form-item label="Area of Work You were / are in">
                    <a-select v-decorator="[
                        'job',
                        {
                            rules: [
                                {
                                    required: true,
                                    message: 'Job is required',
                                },
                            ],
                        },
                        
                    ]">
                        <a-select-option v-for="val in curjob" :key="val" :value="val">{{ val }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="If area of work is other: ">
                    <a-input size="large" v-decorator="[
                        'other', {
                            initialValue: 'N/A',
                            rules: [{required: true, message: 'Job is required'}]
                        }
                    ]"></a-input>
                </a-form-item>
                <!-- <a-form-item label="Choose the program(s) you are interested in">
                    <a-checkbox-group v-decorator="[
                        'program',{
                            rules: [
                                {
                                    required: true,
                                    message: 'program is required',
                                },
                            ],
                        }
                    ]">
                        <a-checkbox value="workshop">
                            <h6>Workshop</h6>
                            <p>
                                Our live and prerecorded workshops will include intergenerational topics, and provide an
                                opportunity for the older adults and students to interact in a group setting. For more
                                information or to request a workshop, click here.
                            </p>
                        </a-checkbox>
                        <a-checkbox value="Teach-n-Trade">
                            <h6>Teach-n-Trade</h6>
                            <p>
                                Our Teach n’ Trade program engages students and older adults in a 7 week program to teach
                                each other new skills through a structured process which incorporates the interests and
                                passions of each individual.
                            </p>
                        </a-checkbox>
                    </a-checkbox-group>
                </a-form-item> -->
                <div v-if="role === 'volunteer'">
                    <a-form-item label="Explain in under 100 words why you want to volunteer with us.">
                        <a-textarea v-decorator="[
                            'reason',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            'We need to know why you want to volunteer with us.',
                                    },
                                ],
                            },
                        ]" />
                    </a-form-item>
                    <a-form-item label="Explain in under 100 words why you think you would be a good fit for this program.">
                        <a-textarea v-decorator="[
                            'goodFit',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            'We need to know why you think you would be a good fit for this program.',
                                    },
                                ],
                            },
                        ]" />
                    </a-form-item>
                    <a-form-item
                        label="Have you ever been convicted of any statute of any Province of Canada that carries a maximum incarceration period of six (6) months or more?">
                        <a-radio-group v-decorator="[
                            'statute',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            'We need to know your conviction of statute in Canada',
                                    },
                                ],
                            },
                        ]">
                            <a-radio :value="true">Yes</a-radio>
                            <a-radio :value="false">No</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label='Have you ever been convicted of any offence under the Criminal Code of Canada?'>
                        <a-radio-group v-decorator="[
                            'crime',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            'We need to know your convicted of offence under the Criminal Code in Canada',
                                    },
                                ],
                            },
                        ]">
                            <a-radio :value="true">Yes</a-radio>
                            <a-radio :value="false">No</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="Over the next year, what are your commitments?">
                        <a-textarea v-decorator="[
                            'commitments',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'We need to know your commitments.',
                                    },
                                ],
                            },
                        ]">
                        </a-textarea>
                    </a-form-item>
                    <a-form-item
                        label="How long would you like to volunteer with Sunshine Connected? Minimum period is 6 months following training completion. ">
                        <a-input v-decorator="[
                            'timeToBe',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            'We need to know how long you like to be volunteer.',
                                    },
                                    {
                                        validator: (_, value, cb) => {
                                            Number(value) >= 6
                                                ? cb()
                                                : cb('Minimum period is 6 months ');
                                        },
                                    },
                                ],
                            },
                        ]" suffix="Months" />
                    </a-form-item>
                    <a-form-item label="What languages are you fluent in?">
                        <a-checkbox-group :options="[
                            { label: 'English', value: 'en' },
                            { label: 'French', value: 'fr' },
                        ]" v-decorator="[
    'langFluent',
    {
        rules: [
            {
                required: true,
                message:
                    'We need to know which language you fluent in.',
            },
        ],
    },
]" />
                    </a-form-item>
                    <a-form-item
                        label="Please tell us about your interest and skills, no qualifications are required of volunteers.">
                        <a-textarea v-decorator="[
                            'skillIntro',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            'We need to know your interest and skills.',
                                    },
                                ],
                            },
                        ]"></a-textarea>
                    </a-form-item>
                    <a-form-item label="How did you hear about Sunshine Connected?">
                        <a-textarea v-decorator="[
                            'howHear',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            'We need to know your interest and skills.',
                                    },
                                ],
                            },
                        ]">
                        </a-textarea>
                    </a-form-item>
                </div>
            </a-form>
        </div>

        <div class="buttom">
            <a-button type="primary" @click="handleSubmit">Next Step</a-button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['role', 'handleQuiz','defaultValue'],
    data() {
        return {
            form: this.$form.createForm(this, { name: "quiz", props: 'defaultValue' }),
            other: null,
            options: [
                "Animal and Pets",
                "Architechture",
                "Reading",
                "Education",
                "Fashion",
                "Films/TV",
                "Health/Fitness",
                "History",
                "Music",
                "Photography",
                "Science/Nature",
                "Sports",
                "Technology",
            ],
            curjob: [
                "Healthcare and medicine",
                "Arts and entertainment",
                "Business",
                "Industrial and manufacturing",
                "Law enforcement and armed forces",
                "Science and technology",
                "Food or drink industry",
                "Education Industry",
                "Politics",
                "Stay at home parent",
                "Other",
            ],
        }
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault()
            this.form.validateFields((err, values) => {
                if (!err) {
                    if (values.job == 'Other') {
                        if (values.other == "N/A") {
                            this.form.setFields({'other':{errors: [Error("If you select other, you must have a valid input")]}})
                            return
                        }
                        values.job = values.other
                    }
                    delete values.other
                    console.log(values)
                    this.handleQuiz(values)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.CenteredContent {
    padding: 6.25rem 5rem;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    .title {
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 40px;
        font-family: auto;
        text-align: center;
    }

    .intro {
        text-align: center;
    }

    .inputContainer {
        width: 100%;
        max-width: 700px;
        padding: 2rem 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .w100 {
            width: 100%;
        }
    }
}
</style>